import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data";

export const EditorialMarquee = () => {
  return (
    <div
      data-testid="marquee"
      className="border-y border-border bg-muted/40 py-6 overflow-hidden"
      aria-hidden="true"
    >
      <Marquee speed={28} gradient={false} autoFill>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl lg:text-4xl font-light uppercase tracking-wide text-muted-foreground px-8">
              {item}
            </span>
            <span className="text-accent text-xl">&#10022;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
